// React
import React from 'react'
import ReactDOM from 'react-dom/client'
import { RecoilRoot } from 'recoil'
import * as Sentry from "@sentry/browser";

// Providers
import FontAwesomeProvider from './src/providers/FontAwesomeProvider'
import { Provider } from 'react-redux'
import store from './src/store/index'
import Logger, { LogLevel } from './src/singletons/Logger'
import AppLayout from './src/layout/app'

if (process.env.NODE_ENV !== 'production') {
  Logger.logLevel = LogLevel.Debug
} else {
  Logger.logLevel = LogLevel.Error
}

Sentry.init({
  dsn: 'https://36f9ef5c545b48bfa0b0ecf3a89a807d@sentry.dessol.com/3',
  environment: process.env.NODE_ENV,
  tracesSampleRate: process.env.NODE_ENV === "production" ? 0.2 : 1.0,
  profilesSampleRate: process.env.NODE_ENV === "production" ? 0.1 : 1.0,
  beforeSend(event) {
    // Check if it is an exception, and if so, show the report dialog
    if (event.exception && event.event_id) {
      Sentry.showReportDialog({ eventId: event.event_id });
    }

    return event;
  }
})

// Temporary fix for dynamic pages created in gatsby-node.
// The issue is caused by the Chakra Plugin usage with the createPages API in Gatsby Node.
export function replaceHydrateFunction() {
  return (element, container) => {
    const root = ReactDOM.createRoot(container)
    root.render(element)
  }
}

export const wrapRootElement = ({ element }) => (
  <RecoilRoot>
    <Provider store={store}>
      <FontAwesomeProvider>
        {element}
      </FontAwesomeProvider>
    </Provider>
  </RecoilRoot>
)

export const wrapPageElement = ({ element }) => {
  return (
    <AppLayout>
      {element}
    </AppLayout>
  )
}